'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconRedo = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M22.608.161a.5.5 0 0 0-.545.108L19.472 2.86a.25.25 0 0 1-.292.045 12.537 12.537 0 0 0-12.966.865A12.259 12.259 0 0 0 6.1 23.632a1.25 1.25 0 0 0 1.476-2.018 9.759 9.759 0 0 1 .091-15.809 10 10 0 0 1 9.466-1.1.25.25 0 0 1 .084.409l-1.85 1.85a.5.5 0 0 0 .354.853h6.7a.5.5 0 0 0 .5-.5V.623a.5.5 0 0 0-.313-.462z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M6.208 24a.49.49 0 0 1-.295-.097 11.982 11.982 0 0 1-2.674-2.706 11.926 11.926 0 0 1-2.075-8.953 11.928 11.928 0 0 1 4.863-7.798 12.038 12.038 0 0 1 7.012-2.233c3.436 0 6.664 1.411 8.958 3.895V.498a.5.5 0 0 1 1 0v7a.307.307 0 0 1-.006.057.477.477 0 0 1-.148.3.344.344 0 0 1-.054.051.446.446 0 0 1-.078.041.47.47 0 0 1-.165.047.301.301 0 0 1-.049.005h-7a.5.5 0 0 1 0-1h5.957c-2.115-2.412-5.152-3.785-8.413-3.785-2.323 0-4.548.708-6.434 2.048-2.391 1.707-3.974 4.246-4.457 7.146s.193 5.815 1.902 8.208a10.966 10.966 0 0 0 2.451 2.48.499.499 0 0 1 .108.699.497.497 0 0 1-.403.205z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M11.993 23.998c-6.613 0-11.996-5.38-12-11.993a11.92 11.92 0 0 1 3.514-8.484 11.92 11.92 0 0 1 8.479-3.523c4.389 0 8.426 2.438 10.514 6.21V.748a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1 0-1.5h5.729a10.46 10.46 0 0 0-9.486-6 10.435 10.435 0 0 0-7.425 3.083 10.434 10.434 0 0 0-3.075 7.423c.003 5.786 4.714 10.494 10.5 10.494.42 0 .757.336.757.75 0 .413-.339.75-.757.75z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconRedo.displayName = 'IconRedo';
exports.default = IconRedo;